import Vue from 'vue'
import VueEditorPlugin from 'vue2-editor'

Vue.use(VueEditorPlugin)
